import { AxiosResponse } from 'axios'
import { IApiSuccessResponse } from 'interfaces/api-success-response'
import httpClient from './base-service'
import {
  IMenuSearchResponse,
  IMenuGetRequest,
  IMenuDetailData,
  IMenutList,
} from '../interfaces/menu'
import { ModifierGroup } from '../interfaces/modifier-groups'

export interface MenuItemDetailResponse {
  menuItemId: number
  posItemId?: string
  menuCategoryId: number
  name: string
  description?: string
  position: number
  price: number
  isActive: boolean
  imagePath?: string
  taxPercentage?: number
  isModifierRequired: boolean
  isAddOnRequired: boolean
  isAlcohol: boolean
  modifiers: MenuItemModifier[]
  addOns: MenuItemModifier[]
  instructionalModifiers: MenuItemModifier[]
  filterTypeIds: number[]
}

export interface MenuItemModifier {
  id: number
  name: string
  price: number
  taxPercentage?: number
}

const endPointBaseURL = `/Menu`

const getAllMenu = async (
  requestBody: IMenutList
): Promise<AxiosResponse<IApiSuccessResponse<IMenuSearchResponse[]>>> =>
  httpClient.post<IApiSuccessResponse<IMenuSearchResponse[]>>(
    `${endPointBaseURL}/get-menu`,
    requestBody
  )

// getMenucat
const geMenubyMenuId = async (
  requestBody: IMenuGetRequest
): Promise<AxiosResponse<IApiSuccessResponse<IMenuDetailData>>> =>
  httpClient.post<IApiSuccessResponse<IMenuDetailData>>(
    `${endPointBaseURL}/get-menu-by-id`,
    {
      menuId: requestBody.menuId,
      includeAllFields: requestBody.includeAllFields,
    }
  )

const getMenuItemWithModifiers = async (
  menuItemId: number
): Promise<AxiosResponse<IApiSuccessResponse<MenuItemDetailResponse>>> =>
  httpClient.post<IApiSuccessResponse<MenuItemDetailResponse>>(
    `/MenuItem/get-menu-item-with-modifiers`,
    {
      menuItemId,
    }
  )

const getMenuItemModifierGroups = async (
  menuItemId: number
): Promise<AxiosResponse<IApiSuccessResponse<ModifierGroup[]>>> =>
  httpClient.get<IApiSuccessResponse<ModifierGroup[]>>(
    `/modifier-group/menu-item/${menuItemId}`
  )

export default {
  getAllMenu,
  geMenubyMenuId,
  getMenuItemWithModifiers,
  getMenuItemModifierGroups,
}
